import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

import { Context } from "../../../context";
import { getMonthsTexts } from "../../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function isMonthStart(dt: DateTime) {
  return dt.day === 1;
}

function startMonth(months: DateTime[][], startDate: DateTime) {
  return [...months, [startDate]];
}

function isInMonth([firstDt]: DateTime[], dt: DateTime) {
  return firstDt.month === dt.month && firstDt.year === dt.year;
}

function findMonthIndex(months: DateTime[][], dt: DateTime) {
  return months.findIndex((month) => isInMonth(month, dt));
}

function addToMonth(months: DateTime[][], dt: DateTime) {
  const index = findMonthIndex(months, dt);

  return index >= 0
    ? [
        ...months.slice(0, index),
        [...months[index], dt],
        ...months.slice(index + 1),
      ]
    : [...months, [dt]];
}

function getMonths(dates: DateTime[]) {
  return dates.reduce<DateTime[][]>(
    (months, dt) =>
      isMonthStart(dt) ? startMonth(months, dt) : addToMonth(months, dt),
    [],
  );
}

function Year({ year }: Props) {
  const firstDt = year[0];
  const { t } = useTranslation();
  const { cell } = React.useContext(Context);
  const months = getMonthsTexts(t);

  return (
    <div className={styles.year}>
      <p className={styles.yearName}>{firstDt.year}</p>
      <div className={styles.months}>
        {getMonths(year).map((month, index) => {
          const monthIndex = month[0].month - 1;

          return (
            <div
              key={index}
              className={classNames(styles.month, {
                [styles.even]: monthIndex % 2 === 0,
                [styles.odd]: monthIndex % 2 !== 0,
              })}
              style={{ width: cell.width * month.length }}
            >
              {months[monthIndex][0]}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { Year };
